import React from 'react';
import { Logo } from './Logo';
export const HeroSection = () => {
  return <section className="relative bg-gradient-to-b from-slate-50 to-slate-100 py-20 overflow-hidden" data-id="element-122">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-123">
        <div className="lg:grid lg:grid-cols-12 lg:gap-8" data-id="element-124">
          <div className="sm:text-center md:max-w-2xl md:mx-auto lg:col-span-6 lg:text-left" data-id="element-125">
            <div className="mt-6" data-id="element-126">
              <h1 className="text-4xl tracking-tight font-extrabold text-slate-800 sm:text-5xl md:text-6xl" data-id="element-127">
                <span className="block" data-id="element-128">Aurum Grove Capital</span>
                <span className="block text-[#D4AF37]" data-id="element-129">
                  Cultivating wealth for generations
                </span>
              </h1>
              <p className="mt-6 text-base text-slate-600 sm:text-lg md:text-xl" data-id="element-130">
                Aurum Grove Capital manages investments for a select group of
                family and friends in the Indian market, with a long-term
                approach focused on sustainable growth and wealth preservation.
              </p>
              <div className="mt-10 sm:flex sm:justify-center lg:justify-start" data-id="element-131">
                <div className="rounded-md shadow" data-id="element-132">
                  <a href="#contact" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-white bg-[#D4AF37] hover:bg-[#C9A227] md:py-4 md:text-lg md:px-10" data-id="element-133">
                    Contact Us
                  </a>
                </div>
                <div className="mt-3 sm:mt-0 sm:ml-3" data-id="element-134">
                  <a href="#about" className="w-full flex items-center justify-center px-8 py-3 border border-transparent text-base font-medium rounded-md text-[#D4AF37] bg-white hover:bg-slate-50 md:py-4 md:text-lg md:px-10" data-id="element-135">
                    Learn More
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="mt-12 relative sm:max-w-lg sm:mx-auto lg:mt-0 lg:max-w-none lg:mx-0 lg:col-span-6 lg:flex lg:items-center" data-id="element-136">
            <div className="relative mx-auto w-full rounded-lg shadow-lg lg:max-w-md" data-id="element-137">
              <div className="relative block w-full bg-white p-10 rounded-lg" data-id="element-138">
                <Logo data-id="element-139" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};